import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class{

    constructor( options ) {
        this.defaults = {
            $el   : false,
        };

        this.options = {};
        Object.assign(this.options, this.defaults, options);
        this.namespace      = 'data-graphic-scroll';
        this.$el            = this.options.$el;
        this.main           = this.options.main;

        this.$panels        = this.$el.find('.panel');
        this.$background    = this.$el.find('.background');
        this.$slick         = this.$el.find('.slick-slider');

        this.init();
        this.$el.addClass('init');

    }

    init(){

        this.addEvents( true );

    }

    addEvents( b ){
        if ( b ){

            let _this = this;

            // Background pinning:
            ScrollTrigger.create({
                trigger: this.$el,
                id: 'datagraphic-'+ this.options.index +'-background',
                start: "top top",
                pin: this.$background,
                pinSpacing: false,
                end: ()=>{ return _this.$el.offset().top + _this.$el.height() - $(window).height() },
                toggleClass: "activate-nav-compact",
                markers: false,
            });

            // Panel in view triggers
            this.$panels.each( (i, el) => {
                let $el = $(el);
                ScrollTrigger.create({
                    trigger: $el,
                    id: 'datagraphic-'+ this.options.index +'-panel-'+i,
                    markers: false,
                    onEnter: self => {
                        // console.log( 'Go to slide: ' + $el.data('image') );
                        this.$slick.slick('slickGoTo', $el.data('image') );
                    },
                    onEnterBack: self =>{
                        // console.log( 'Go to slide (back): ' + $el.data('image') );
                        this.$slick.slick('slickGoTo', $el.data('image') );
                    },
                });
            });


        } else {

            ScrollTrigger.getById( 'datagraphic-'+ this.options.index +'-background' ).kill();
            
            this.$panels.each( (i, el) => {
                ScrollTrigger.getById( 'datagraphic-'+ this.options.index +'-panel-'+i ).kill();
            });

        }
    }


    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
        if ( this.$el.length > 0 ){
            this.addEvents( false );
            this.$el.removeData();
        }
    }

}